export const buildAttributeTransPath = (attributeId: string): string => {
  return `attributes.${attributeId}`;
};

export const buildOptionTransPath = (attributeId: string, optionId: string): string => {
  return `${buildAttributeTransPath(attributeId)}.options.${optionId}`;
};

export const buildProductTypeTransPath = (productType: string): string => {
  return `productTypes.${productType}`;
};
